// extracted by mini-css-extract-plugin
export default {"banner_wrapper":"Banner_banner_wrapper__V1j5t","banner_link":"Banner_banner_link__2z5dK","banner_btn":"Banner_banner_btn__Nn0rX"};